var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPmMastercardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3267 8.23828H11.6738V23.7878H20.3267V8.23828Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2232 16.014C12.2218 14.5165 12.5611 13.0383 13.2155 11.6913C13.8699 10.3443 14.8222 9.16385 16.0002 8.23928C14.5414 7.0926 12.7893 6.3795 10.9444 6.18148C9.09943 5.98346 7.23598 6.30851 5.56703 7.11948C3.89808 7.93045 2.49096 9.19462 1.50651 10.7675C0.522061 12.3404 0 14.1585 0 16.014C0 17.8696 0.522061 19.6877 1.50651 21.2606C2.49096 22.8335 3.89808 24.0976 5.56703 24.9086C7.23598 25.7196 9.09943 26.0446 10.9444 25.8466C12.7893 25.6486 14.5414 24.9355 16.0002 23.7888C14.8222 22.8642 13.8699 21.6838 13.2155 20.3368C12.5612 18.9898 12.2218 17.5116 12.2232 16.014Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 16.014C32 17.8696 31.478 19.6877 30.4936 21.2606C29.5092 22.8334 28.1022 24.0976 26.4332 24.9086C24.7643 25.7196 22.9009 26.0446 21.056 25.8466C19.211 25.6486 17.459 24.9355 16.0002 23.7888C17.1772 22.8633 18.1288 21.6827 18.783 20.3359C19.4373 18.9891 19.7773 17.5113 19.7773 16.014C19.7773 14.5167 19.4373 13.039 18.783 11.6922C18.1288 10.3454 17.1772 9.16478 16.0002 8.23928C17.459 7.0926 19.211 6.37949 21.056 6.18148C22.9009 5.98346 24.7643 6.30852 26.4332 7.1195C28.1022 7.93048 29.5092 9.19465 30.4936 10.7675C31.478 12.3404 32 14.1585 31.9999 16.014Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0566 22.1416V21.8233H31.1849V21.7584H30.858V21.8233H30.9865V22.1416H31.0566ZM31.6913 22.1416V21.7578H31.5911L31.4758 22.0218L31.3605 21.7578H31.2602V22.1416H31.331V21.8521L31.4391 22.1017H31.5125L31.6206 21.8515V22.1416H31.6913Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmMastercardIcon);
export default __webpack_public_path__ + "static/media/pm-mastercard-icon.e6799d2c7462004a3198a5d1b3e1e6fb.svg";
export { ForwardRef as ReactComponent };